import React from 'react';
import PropTypes from 'prop-types';
import { FormLabel } from 'react-bootstrap';
import translate from '../../translate';
import FormInput from '../FormInput';
import CountryProp from './CountryProp';
import AddressProp from './AddressProp';
import Loader from '../../../services/loader';
import GoogleInput from '../inputs/GoogleInput';
import UserProp from '../../propTypes/userProp';

class FormAddressFragment extends React.Component {
  constructor(props) {
    super(props);

    this.loader = null;
    this.setLoading = this.setLoading.bind(this);
  }

  componentDidMount() {
    this.loader = new Loader('#form-address-fragment');
  }

  setLoading(isLoading) {
    return () => (isLoading ? this.loader.show() : this.loader.hide());
  }

  render() {
    const {
      t,
      countries,
      address,
      onFieldChange,
      translationPrefix,
      style,
      isShopCheckout,
      countryToFilter,
      isShippingAddress,
      user,
      googleSearchLabelClass,
    } = this.props;

    const onInputChange = field => value => {
      if (field === 'countryCode') {
        onFieldChange(field)(value);
        const country = countries.find(c => c.code === value);
        if (country) {
          onFieldChange('country')(country.name);
        }
      } else {
        onFieldChange(field)(value);
      }
    };
    const createInput = (required, field, typeParam, autocomplete, isDisabled) => {
      const type = typeParam || 'text';
      const inputProps = () => {
        switch (field) {
          case 'countryCode':
            return {
              required: true,
              placeholder: t(`${translationPrefix}_countryCodePlaceholder`),
              items: countries.map(c => ({
                id: c.code,
                text: `${c.flagEmoji} ${c.name}`,
              })),
              autocomplete,
              disabled: isDisabled,
            };
          case 'address_2':
            return {
              maxLength: 35,
            };
          default:
            return {
              required,
              autocomplete,
            };
        }
      };
      const defaultValue = '';

      return (
        <FormInput
          id={field}
          name={field}
          value={address[field] || defaultValue}
          onChange={onInputChange(field)}
          label={t(`${translationPrefix}_${field}`)}
          labelClassName=""
          containerClassName=""
          placeholder={t(`${translationPrefix}_${field}`)}
          type={type}
          inputProps={inputProps()}
        />
      );
    };
    const onGoogleInputChange = e => {
      onFieldChange('address_1')(e.address_1);
      onFieldChange('city')(e.city);
      onFieldChange('zipCode')(e.zipCode);
      onFieldChange('state')(e.state);
      onFieldChange('countryCode')(e.countryCode);
      if (e.countryCode.length > 0) {
        const country = countries.find(c => c.code === e.countryCode);
        if (country) {
          onFieldChange('country')(country.name);
        }
      }
    };

    const handleOnAddressChange = field => addressParam => {
      if (addressParam) {
        onFieldChange(field)(addressParam);
      }
    };
    const createGoogleInput = value => {
      const inputLabel = t(`${translationPrefix}_address_1`);
      return (
          <div className="form-group m-form__group">
            <FormLabel className={googleSearchLabelClass}>{inputLabel}</FormLabel>
            <GoogleInput
              name="address_1"
              onChange={onGoogleInputChange}
              placeholder={inputLabel}
              updateValue={value}
              onSetValue={handleOnAddressChange('address_1')}
              filterByCountry={address.countryCode || (isShippingAddress ? countryToFilter : null)}
            />
          </div>);
    };
    // Disabled or not the Country in checkout
    const disabledCountryInputCheckout = isShopCheckout && isShippingAddress && countryToFilter;

    const isIndividual = user?.personalInfo?.businessType === 'individual' || !user?.personalInfo?.businessType;
    return (
      <div id="form-address-fragment" style={style}>
        {!isShippingAddress && !isIndividual && createInput(false, 'companyName', 'text', 'off')}
        {createInput(!isShippingAddress, 'firstName', 'text', 'new-firstName')}
        {createInput(!isShippingAddress, 'lastName', 'text', 'new-lastName')}
        {createInput(false, 'email', 'email', 'new-email')}
        {createInput(true, 'phone', 'text', 'new-phone')}
        {createGoogleInput(address.address_1)}
        {createInput(false, 'address_2', 'text', 'new-address2')}
        {createInput(true, 'city', 'text', 'new-city')}
        {createInput(true, 'zipCode', 'text', 'new-zipCode')}
        {createInput(false, 'state', 'text', 'new-state')}
        {createInput(true, 'countryCode', 'select', 'new-countryCode', disabledCountryInputCheckout, countryToFilter)}
      </div>
    );
  }
}

FormAddressFragment.propTypes = {
  t: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  address: PropTypes.shape(AddressProp.propType).isRequired,
  onFieldChange: PropTypes.func.isRequired,
  translationPrefix: PropTypes.string,
  style: PropTypes.shape(),
  // Currently this form is only used is ShopCheckoutShipping
  // flag to make sure that the behavior is only in that case (in the future)
  isShopCheckout: PropTypes.bool,
  countryToFilter: PropTypes.string,
  isShippingAddress: PropTypes.bool,
  user: PropTypes.shape(UserProp.propType).isRequired,
  googleSearchLabelClass: PropTypes.string,
};

FormAddressFragment.defaultProps = {
  translationPrefix: 'address',
  googleSearchLabelClass: '',
  style: {},
  isShopCheckout: false,
  countryToFilter: null,
  isShippingAddress: false,
};

export default translate(FormAddressFragment);
